// noinspection GraphQLUnresolvedReference

export const getGlobalNote = /* GraphQL */ `
    query GetGlobalNote {
        globalsEntries {
            ... on globals_Entry {
                noteColor
                noteText
            }
        }
    }
`;
